import styled from '@emotion/styled';
import 'react';

interface BodyStyleProps {
  flex?: boolean;
}

export default styled('div')<BodyStyleProps>`
  padding: 30px;
  flex-grow: 1;
  ${(props) => (props.flex ? 'display: flex;' : '')}
`;
